module.exports = __webpack_public_path__ + "img/qa.2db98b37.png";